<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark grow style="height: 100%">
      <v-tab
        v-for="item in tabs"
        v-if="isAccessible(item)"
        :key="item.index"
        :disabled="$route.name !== item.componentPath"
        :to="{ name: item.componentPath, query: { ...$route.query } }"
      >
        {{ item.name }}
      </v-tab>

      <v-tab-item :value="tab" class="pb-6">
        <v-sheet class="mx-auto" max-width="1230">
          <Loader v-if="isLoading" overlay="1"/>
          <router-view v-else :routeName="routeName"/>
        </v-sheet>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import { FormulairePremiereInscription } from "@/utils/formulaireDefinitions"
import FormulaireMixin from "@/mixins/formulaireMixin"
import ParamFormulaire from "@/mixins/paramFormulaire"
import Loader from "@/components/Loader.vue";

export default {
  components: { Loader },
  mixins: [FormulaireMixin, ParamFormulaire],
  props: {
    routeName: {
      type: String,
      default: FormulairePremiereInscription.routeName,
    },
  },
  data() {
    return {
      tab: "",
      tabs: [],
    }
  },
  computed: {
    ...mapGetters({
      isValidee: "DemandeInscription/IS_VALIDEE",
      isDemandeTerminee: "DemandeInscription/IS_DEMANDE_TERMINEE",
      isRetraitVolontaire: "DemandeInscription/IS_RETRAIT_VOLONTAIRE",
      getAccesFormulairePremiereInscription: "DemandeInscription/GET_ACCES_FORMULAIRE_PREMIERE_INSCRIPTION",
    }),
    isLoading() {
      return this.tabs.length === 0
    },
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireInscription)
  },
  async created() {
    this.autoRedirect()

    await this.handleAuthorization()
    await this.handleDemandeInscription()

    if (this.isRetraitVolontaire == true) {
      this.$router.push({ name: "DemandeInscription/RetraitVolontaire", query: { ...this.$route.query } })
    } else if (this.isValidee == true || this.isDemandeTerminee == true) {
      this.$router.push({ name: "DemandeInscription/DemandeDejaValidee", query: { ...this.$route.query } })
    }

    // tout est validé, on ouvre le formulaire
    this.tabs = FormulairePremiereInscription.getTabs()
  },
  methods: {
    ...mapMutations({
      setDemandeInscriptionId: "DemandeInscription/SET_ID",
      setContactId: "DemandeInscription/SET_CONTACTID",
    }),
    ...mapActions({
      fetchAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
      fetchDemandeInscription: "DemandeInscription/fetchDemandeInscription",
      getContactAccesFormulaires: "DemandeInscription/getContactAccesFormulaires",
    }),
    async handleAuthorization() {
      try{
        if (this.$route.query.contactId == null) {
        this.$router.push({ name: "InternalError", params: { message: "Un contact est obligatoire" } })
        return;
        } else {
          this.setContactId(this.$route.query.contactId)
        }
        await this.getContactAccesFormulaires(this.$route.query.contactId)
        if(!this.getAccesFormulairePremiereInscription){
          this.$router.push({ name: "InternalError", params: { message: "Vous n'avez pas les droits nécessaires pour accéder à cette page" } })
        }
      }
      catch{
        this.$router.push({ name: "InternalError", params: { message: "Une erreur est survenue lors de la tentative d'autorisation" } })
      }
    },
    async handleDemandeInscription() {
      if (this.$route.query.demandeInscriptionId != null) {
        this.setDemandeInscriptionId(this.$route.query.demandeInscriptionId)
        await this.fetchDemandeInscription(this.$route.query.demandeInscriptionId)
        this.fetchAutorisationDePratiqueByDemandeInscriptionId(this.$route.query.demandeInscriptionId)
      }
    },
    autoRedirect() {
      if (this.$route.name == this.routeName) {
        this.$router.push({
          name: `${this.routeName}/RenseignementsGeneraux`,
          query: { ...this.$route.query },
        })
      }
    },
  },
}
</script>

<style></style>